import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Drawer, useMediaQuery, IconButton, Divider, Tooltip } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/logo/snall-logo.svg";
import { ReactComponent as Paint } from "../../assets/icons/paint.svg";
import { ReactComponent as Spreadsheet } from "../../assets/icons/spreadsheet.svg";
import { ReactComponent as Search } from "../../assets/icons/search.svg";
import { ReactComponent as Users } from "../../assets/icons/users.svg";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import { config } from "../../constants";
import { clearUser } from "../../store/slice/authSlice";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { handleSignOut } from "../../services/amplify/helpers";
import { setShowSpreadSheet } from "../../store/slice/generalSlice";
import { useAuth } from "../../hooks/useAuth";


const Sidebar = ({ open, openSet }) => {
  const { isAdmin } = useAuth();
  const openSpreadSheetHandler = () => {
    dispatch(setShowSpreadSheet(true));
  }
  const closeSpreadSheetHandler = () => {
    dispatch(setShowSpreadSheet(false));
  }
  const links = [
    { name: "Paint" , handler: closeSpreadSheetHandler, icon: <Paint /> },
    { name: "Spreadsheet", handler: openSpreadSheetHandler, icon: <Spreadsheet /> },
    { name: "Search", path: "/image-search", icon: <Search /> },
    // Users link will be conditionally rendered below
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(config.MD_BREAKPOINT);

  async function logout() {
    window.isManualLogout = true;
    let response = await handleSignOut();
    if (response.isSignedOut) {
      dispatch(clearUser());
      toast.success("Logout Success");
    } else {
      toast.error(response.error);
    }
  }

  function handleClose() {
    openSet((prev) => !prev);
  }

  useEffect(() => {
    open && handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);


  return (
    <Drawer
      sx={{
        "& .MuiDrawer-paper": {
          width: isSmallScreen ? "96px" : "96px",
          borderRadius: "0px 20px 20px 0px",
        },
      }}
      anchor="left"
      open={open}
      onClose={handleClose}
      hideBackdrop={isSmallScreen ? false : true}
      variant={isSmallScreen ? "temporary" : "permanent"}
    >
      <div className="w-full h-full p-4 py-10 flex flex-col items-center justify-between">
        <div className="flex flex-col gap-10">
          <div onClick={() => navigate("/", { state: { from: location.pathname, ...location.state }, replace: false })} className="cursor-pointer">
            <Logo />
          </div>
          <Divider flexItem />
          <div className="flex flex-col gap-10">
            {location.pathname === "/property-sheet/detail" ?
              <>
                {links.filter(link => link.name !== "Users").map((link, index) => (
                  <Link key={index} link={link} isSmallScreen={isSmallScreen} />
                ))}
                {isAdmin && (
                  <Tooltip title="User Management">
                    <div>
                      <Link link={{ name: "Users", path: "/user-management", icon: <Users /> }} isSmallScreen={isSmallScreen} />
                    </div>
                  </Tooltip>
                )}
              </>
              :
              <>
                <Tooltip title="Search by Image">
                  <div>
                    <Link link={links.find(link => link.name === "Search")} isSmallScreen={isSmallScreen} />
                  </div>
                </Tooltip>
                {isAdmin && (
                  <Tooltip title="User Management">
                    <div>
                      <Link link={{ name: "Users", path: "/user-management", icon: <Users /> }} isSmallScreen={isSmallScreen} />
                    </div>
                  </Tooltip>
                )}
              </>
            }
          </div>
        </div>
        <Divider flexItem />
        
        <Tooltip title="Logout">
          <IconButton onClick={logout}>
            <Logout />
          </IconButton>
        </Tooltip>
      </div>
    </Drawer>
  );
};

export default Sidebar;

const Link = ({ link, isSmallScreen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (link?.handler) {
    return (<div className="flex gap-2 items-center justify-center cursor-pointer" onClick={link?.handler}>
      {link.icon}
      {/* {isSmallScreen && <div className={`${props.isActive ? "" : ""}`}>{link.name}</div>} */}
    </div>)
  }

  return (
    <NavLink
      to={link.path}
      state={{ from: location.pathname, ...location.state }}
      onClick={(e) => {
        e.preventDefault();
        navigate(link.path, { state: { from: location.pathname, ...location.state }, replace: false });
      }}
    >
      <div className="flex gap-2 items-center justify-center">
        {link.icon}
        {/* {isSmallScreen && <div className={`${props.isActive ? "" : ""}`}>{link.name}</div>} */}
      </div>
    </NavLink>
  );
};
